<template>
  <div class="tags">
    <div class="tag tag-poste"
      :style="{ backgroundImage: `url(${posteTravauxImage})` }"
      >
      <div class="tooltip">
        <span>{{ tooltipTravaux }}</span>
      </div>
    </div>
    <div class="tag tag-money"
      :class="{ activ: tags.ressource }">
      <div class="tooltip">
        <span>{{ tooltipRessources }}</span>
      </div>
    </div>
    <div class="tag tag-compas"
      :class="{ activ: tags.tiers }">
      <div class="tooltip">
        <span>{{ tooltipTiers }}</span>
      </div>
    </div>
    <div class="tag tag-rge"
      :class="{ activ: tags.rge }">
      <div class="tooltip">
        <span>{{ tooltipRge }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagsAide',
  props: {
    tags: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      groupsLabel: {
        global: 'Nécéssite une intervention globale sur le bâti et les équipements du logement',
        'reno-chauffage': 'Nécéssite une intervention sur les équipements du logement',
        'reno-bati': 'Nécéssite une intervention sur le bâti du logement',
        pac: 'Nécéssite une intervention impliquant une Pompe à chaleur',
        'equipement-solaire': 'Nécéssite une intervention impliquant des équipements solaires'
      }
    }
  },
  computed: {
    travaux () {
      return this.$store.state.travaux
    },
    tooltipTravaux () {
      return this.isGroup
        ? this.groupsLabel[this.group]
        : 'Nécéssite une intervention sur le poste ' + this.travaux[this.tags.travaux[0]].label.toLowerCase()
    },
    tooltipRessources () {
      return this.tags.ressource
        ? 'Conditions de ressources exigées'
        : 'Pas de conditions de ressources exigées'
    },
    tooltipTiers () {
      return this.tags.tiers
        ? 'Requiert l\'intervention d\'un Bureau d\'Études ou d\'un architecte'
        : 'Ne nécessite pas obligatoirement l\'intervention d\'un Bureau d\'Études ou d\'un architecte'
    },
    tooltipRge () {
      return this.tags.rge
        ? 'L\'entreprise qui effectue les travaux doit être RGE'
        : 'L\'entreprise qui effectue les travaux n\'a pas besoin d\'être RGE'
    },
    isGroup () {
      return this.tags.travaux.length !== 1
    },
    poste () {
      const postes = this.tags.travaux
      if (this.isGroup) {
        return this.group
      } else {
        return this.getPosteImage(postes[0])
      }
    },
    posteTravauxImage () {
      return require(`../../assets/travaux/${this.poste}.svg`)
    },
    group () {
      let groups = []
      if (this.tags.travaux.length) {
        this.tags.travaux.forEach(poste => {
          groups.push(this.travaux[poste].group)
        })
        groups = [...new Set(groups)]
        return groups.length > 1
          ? 'global'
          : groups[0]
      } else {
        return 'global'
      }
    }
  },
  methods: {
    getPosteImage (posteName) {
      return this.travaux[posteName].image
    }
  }
}
</script>

<style lang="scss">
.tags {
  display: flex;
  flex-wrap: wrap;
  width: calc(50px * 2);
  .tag {
    width: 50px;
    height: 40px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;
    .tooltip {
      position: absolute;
      right: calc(50% - 30px);
      top: -40px;
      display: none;
      flex-wrap: wrap;
      height: 30px;
      align-items: center;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.16);
      border-radius: 20px;
      background-color: #fff;
      white-space: nowrap;
      z-index: 30;
      padding: 0 $h-spacer;
      span {
        font-family: $secondary-font;
        font-size: $text-size-sm;
      }
      &:after {
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 15px 15px 0;
        border-color: transparent #ffffff transparent transparent;
        position: absolute;
        right: 30px;
        bottom: -15px;
      }
    }
    &:hover {
      .tooltip {
        opacity: 1;
        display: flex;
      }
    }
    &.tag-money {
      background-image: url('../../assets/pictos/money-off.svg');
      &.activ {
        background-image: url('../../assets/pictos/money.svg');
      }
    }
    &.tag-compas {
      background-image: url('../../assets/pictos/compas-off.svg');
      &.activ {
        background-image: url('../../assets/pictos/compas.svg');
      }
    }
    &.tag-rge {
      background-image: url('../../assets/pictos/rge-off.svg');
      &.activ {
        background-image: url('../../assets/pictos/rge.svg');
      }
    }
  }
}
</style>
